import { render, staticRenderFns } from "./InvoiceAddressSelect.vue?vue&type=template&id=c5c5214c&"
import script from "./InvoiceAddressSelect.vue?vue&type=script&lang=js&"
export * from "./InvoiceAddressSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5c5214c')) {
      api.createRecord('c5c5214c', component.options)
    } else {
      api.reload('c5c5214c', component.options)
    }
    module.hot.accept("./InvoiceAddressSelect.vue?vue&type=template&id=c5c5214c&", function () {
      api.rerender('c5c5214c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/addressSelectCheckoutCustom/InvoiceAddressSelect.vue"
export default component.exports